module.exports = __webpack_public_path__ + "static/assets/b2eb9c0f6676de1f1b94e3a0b3a43e11.png";